import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProjectId } from "../../store/models/Project";
import { AiOndemandApi, selectApiKeys } from "../../store/models/AiOndemandApi";
import { FaCheckCircle, FaEdit, FaTimesCircle } from "react-icons/fa";
import {
  CopyIcon, DownChevronIcon, RotateIcon, DeleteIcon
} from "../Svg";
import { Button } from "../Button";
import UIState, { selectMobileLayout } from "../../store/UIState";
import { toast } from "react-toastify";
import { ModalTypes } from "../../constants";
import Tooltip from "../Tooltip";
import Loader from "../Loader";
import { createSelector } from "reselect";


const selector = createSelector(
  selectMobileLayout,
  selectApiKeys,
  selectCurrentProjectId,
  (isMobile, apiKeys, projectId) => ({
    isMobile,
    apiKeys,
    projectId
  })
)

const AccessTokenTab = ({ }) => {
  const { isMobile, apiKeys, projectId } = useSelector(state => selector(state));
  const filteredAccessToken = apiKeys.filter(k => !k.auto_generated);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const trunc = isMobile ? 10 : 15;


  useEffect(() => {
    (async () => {
      if (!projectId) return;
      if (!loading) setLoading(true);
      try {
        await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
      } catch (e) {
        console.log('Error:', e.message)
      }
      setLoading(false);
    })()
  }, [projectId])

  const handleCreateAccessToken = async () => {
    try {
      await dispatch(AiOndemandApi.actions.createModelApiKey(projectId));
      await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
    } catch (e) {
      console.log('Error:', e.message)
    }
  }



  const handleCopyKey = (key) => {
    navigator.clipboard.writeText(key)
      .then(() => {
        toast.success('Access Token Copied!')
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
      });
  }

  const handleRotateKey = (id) => {
    const onConfirm = async () => {
      try {
        if (!loading) setLoading(true);
        await dispatch(AiOndemandApi.actions.rotateModelApiKey(id));
        await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
        setLoading(false);
        toast.success(`Access Token has been updated.`)
      } catch (e) {
        toast.error(`Oops, something went wrong. Error: ${e.message}`)
      }
    }
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: `Rotate Access Token`,
      message: `Do you want to update the Access Token(${id})?`,
      confirmLabel: `Rotate`,
      cancelLabel: `Close`,
      onConfirm
    }))
  }

  const handleDeleteKey = (id) => {
    const onConfirm = async () => {
      try {
        if (!loading) setLoading(true);
        await dispatch(AiOndemandApi.actions.deleteModelApiKey(id));
        await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
        setLoading(false);
        toast.success(`Access Token has been updated.`)
      } catch (e) {
        toast.error(`Oops, something went wrong. Error: ${e.message}`)
      }
    }
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: `Delete Access Token`,
      message: `Do you want to remove the Access Token(${id})?`,
      confirmLabel: `Delete`,
      cancelLabel: `Close`,
      onConfirm
    }))
  }

  return <div className="OnDemandTokenTab">
    {!loading && filteredAccessToken && filteredAccessToken.length > 0 && <div className="OnDemandTokenTab__ApiKeys">
      <div className="OnDemandTokenTab__ApiKeys--row">
        <div div className="OnDemandTokenTab__ApiKeys--cell name">Name</div>
        <div div className="OnDemandTokenTab__ApiKeys--cell key">Access Token</div>
        {/* <div div className="OnDemandTokenTab__ApiKeys--cell user">Created By</div> */}
        <div div className="OnDemandTokenTab__ApiKeys--cell actions">Actions</div>
      </div>
      {filteredAccessToken.map(key => {
        return (<div key={key.id} className="OnDemandTokenTab__ApiKeys--row">
          <div div className="OnDemandTokenTab__ApiKeys--cell name">
            <NameSection apiKey={key} />
          </div>
          <div div className="OnDemandTokenTab__ApiKeys--cell key">
            {isMobile ? `${key.key.slice(0, trunc)}...${key.key.slice(-trunc)}` : key.key}
          </div>
          {/* <div div className="OnDemandTokenTab__ApiKeys--cell user">{key.user_id}</div> */}
          <div div className="OnDemandTokenTab__ApiKeys--cell actions">
            <div className='OnDemandTokenTab__ApiKey--icons'>
              <Tooltip tooltip={"Copy Access Token"}>
                <div className='OnDemandTokenTab__ApiKey--icon' onClick={() => handleCopyKey(key.key)}>
                  <CopyIcon />
                </div>
              </Tooltip>
              <Tooltip tooltip={"Renew Access Token"}>
                <div className='OnDemandTokenTab__ApiKey--icon' onClick={() => handleRotateKey(key.id)}>
                  <RotateIcon />
                </div>
              </Tooltip>
              <Tooltip tooltip={"Delete Access Token"}>
                <div className='OnDemandTokenTab__ApiKey--icon' onClick={() => handleDeleteKey(key.id)}>
                  <DeleteIcon />
                </div>
              </Tooltip>
            </div>
          </div>
        </div>)
      })}
    </div>
    }
    {
      !loading && (!filteredAccessToken || filteredAccessToken.length === 0) && <div className="OnDemandTokenTab__EmptyState">
        No Access Token for this project yet.
      </div>
    }
    {!loading && <Button title='Create Access Token' color={'green-outline'} onClick={handleCreateAccessToken} disabled={loading} />}
    {loading && <Loader color={'green'} />}
  </div >
}

export default AccessTokenTab;

const NameSection = ({ apiKey }) => {
  const projectId = useSelector(state => selectCurrentProjectId(state));
  console.log('apiKey:', apiKey)
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const nameRef = useRef();
  const handleEdit = () => {
    setIsEditing(true);
  }
  const handleSubmit = async () => {
    let name = nameRef.current.value;
    await dispatch(AiOndemandApi.actions.updateModelApiKeyName(apiKey.id, name));
    await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
    setIsEditing(false);
  }
  const handleCancel = () => {
    setIsEditing(false);
  }
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  }
  return <div onClick={e => e.stopPropagation()} className='OnDemandTokenTab__name-warp'>
    {!isEditing ? _.get(apiKey, 'name') || <span className='OnDemandTokenTab__name-warp--empty'>name empty</span> :
      <input type='text' ref={nameRef} defaultValue={_.get(apiKey, 'name')} onKeyDown={handleKeyDown} />}
    {isEditing ?
      <div className='OnDemandTokenTab__icon-warp'>
        <div className='OnDemandTokenTab__icon cancel' onClick={handleCancel} title="Cancel"><FaTimesCircle /></div>
        <div className='OnDemandTokenTab__icon submit' onClick={handleSubmit} title="Submit"><FaCheckCircle /></div>
      </div> :
      <div className='OnDemandTokenTab__icon-warp'>
        <div className='OnDemandTokenTab__icon edit' onClick={handleEdit}><FaEdit /></div>
      </div>}
  </div>
}